import { convertStatus } from '@components/learningPath/utils';
import { ContentType } from 'learning-panel-components';
import { coreService } from 'network-utils';

const convertSkillTreeToContentCard = (skillTree: coreService.SkillTree) => {
    return {
        uuid: skillTree.uuid,
        type: 'skillTree' as keyof typeof ContentType,
        imageUrl: `${process.env.PUBLIC_URL}/images/skillTreeBackground.webp`,
        name: skillTree.name,
        description: skillTree.description,
        level: skillTree.level,
        completionDate: skillTree.progress?.completedAt,
        potentialScore: skillTree.potentialScore,
        status: convertStatus(skillTree.progress?.status) || 'notStarted',
        displayName: skillTree.name,
        tagline: skillTree.description,
        score: skillTree.potentialScore,
        timeOrDate: String(skillTree.duration),
        cardUrl: `/app/skillTree?uuid=${skillTree.uuid}`,
        dueDate: skillTree.dueDate ? new Date(skillTree.dueDate) : undefined,
        tags: skillTree.tags?.map(tag => tag.displayName)
    };
};

export default convertSkillTreeToContentCard;
